import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_SUBAFFILIATE_SETTINGS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/subaffiliate-condition/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISubaffiliateHistoryChangesResponse } from '../types';
import { SUBAFFILIATE_HISTORY_CHANGES_ITEM_API_URL, SUBAFFILIATE_HISTORY_CHANGES_ITEM_QUERY } from '../constants';

export default function useSubaffiliateHistoryChangesGetQuery(id: Ref<number>, merchantId: Ref<number>): IContextQueryResult<
  ISubaffiliateHistoryChangesResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISubaffiliateHistoryChangesResponse>({
    queryKey: [SUBAFFILIATE_HISTORY_CHANGES_ITEM_QUERY, id],
    queryFn: ({ signal }) => fetchGet<ISubaffiliateHistoryChangesResponse>(
      SUBAFFILIATE_HISTORY_CHANGES_ITEM_API_URL,
      {
        signal,
        permission: AFFILIATE_SUBAFFILIATE_SETTINGS.HISTORY_CHANGES_EDIT,
        urlParams: {
          itemId: id.value,
        },
        queryParams: { merchant: merchantId.value },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
